// removed by extract-text-webpack-plugin
module.exports = {"placeholder":"placeholder","placeholder-title":"placeholder-title","icon":"icon"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/EmptyDataPlaceholder/EmptyDataPlaceholder.scss
// module id = dqR2
// module chunks = 0